import type { Bonus } from '../types/product';

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'The ECG Quick-Reference Cards',
    value: 17,
    headline: 'Review Essential ECG Concepts Without Searching Through Entire Chapters',
    intro: [
      'Sometimes you need a concise visual reminder of a specific ECG concept.',
      'These educational reference cards organize selected information into easy-to-review formats.',
    ],
    items: [
      'ECG waveform terminology cards',
      'P-wave, QRS, and T-wave concept summaries',
      'Common interval reference cards',
      'Heart rate calculation reminders',
      'Rhythm comparison cards',
      'Basic 12-lead ECG concepts',
      'Important measurement considerations',
      'Quick-review questions',
    ],
    why: 'Keep essential ECG concepts organized in a concise format that complements your main learning materials.',
    image: 'https://cdn.magicpatterns.com/uploads/hdJkQ7gQKJZLaC7vY93Dme/BONUS_1_ECG-ECG.png',
  },
  {
    number: 2,
    title: 'The 15-Minute ECG Study Planner',
    value: 12,
    headline: 'Make Your Daily ECG Review Sessions More Focused and Organized',
    intro: [
      'You don’t always need another long chapter.',
      'Sometimes you need a clear way to review one topic, practice a concept, and identify what to study next. This resource provides a repeatable format for focused ECG learning sessions.',
    ],
    items: [
      'Daily study session templates',
      'Topic selection worksheets',
      'Learning objective prompts',
      'Rhythm recognition review questions',
      'ECG measurement exercises',
      'Personal study notes pages',
      'Knowledge-gap identification sheets',
      'Follow-up review checklists',
    ],
    why: 'Use a consistent structure for short educational review sessions without having to plan your study process from scratch.',
    image: 'https://cdn.magicpatterns.com/uploads/bAZDP7HZkuCAamDiy13Rrh/BONUS_2_ECG-EN.png',
    note: 'Fifteen minutes refers to a suggested study-session duration, not guaranteed ECG interpretation proficiency.',
  },
  {
    number: 3,
    title: 'The Cardiac Arrhythmia Visual Comparison Atlas',
    value: 17,
    headline: 'Compare Similar-Looking Cardiac Rhythms Through Clear Visual References',
    intro: [
      'Some rhythm patterns can be difficult to distinguish when studied separately.',
      'This complementary atlas focuses on comparing selected rhythm characteristics side by side.',
    ],
    items: [
      'Sinus rhythm comparison charts',
      'Atrial rhythm comparison tables',
      'Junctional rhythm references',
      'Ventricular rhythm comparison diagrams',
      'Conduction block comparison charts',
      'Common look-alike rhythm examples',
      'ECG artifact examples',
      'Guided pattern-recognition exercises',
    ],
    why: 'Develop a more organized approach to studying rhythm differences through visual comparisons and educational examples.',
    image: 'https://cdn.magicpatterns.com/uploads/cCTdT6XiAdLJmPErjgoUFH/BONUS_3_ECG.png',
  },
  {
    number: 4,
    title: 'The 12-Lead ECG Practice Expansion Pack',
    value: 17,
    headline: 'Get Additional Opportunities to Practice 12-Lead ECG Concepts',
    intro: [
      'Understanding the theory is important. Applying it to different educational examples gives you more opportunities to review your reasoning.',
      'This expansion pack includes additional simulated 12-lead ECG exercises.',
    ],
    items: [
      'Educational 12-lead ECG examples',
      'Lead orientation exercises',
      'Axis concept practice questions',
      'QRS morphology examples',
      'ST-segment educational scenarios',
      'T-wave interpretation exercises',
      'Guided analysis worksheets',
      'Suggested explanations and answer reviews',
    ],
    why: 'Reinforce the concepts covered in Volume IV through additional guided practice.',
    image: 'https://cdn.magicpatterns.com/uploads/5JaynoveYBRZhVkFAr91ij/BONUS_4_ECG-EN.png',
  },
  {
    number: 5,
    title: 'The ECG Interpretation Pitfalls Library',
    value: 12,
    headline: 'Learn Why Common ECG Interpretation Mistakes Happen',
    intro: [
      'A tracing may appear straightforward until additional findings or contextual information change how it should be understood.',
      'This educational library focuses on common misconceptions and interpretation limitations.',
    ],
    items: [
      'Common ECG terminology mistakes',
      'Rhythm recognition misconceptions',
      'Measurement-related pitfalls',
      'Lead placement and artifact examples',
      'ST-segment interpretation limitations',
      'Examples involving incomplete information',
      'Guided reflection questions',
      'Knowledge review exercises',
    ],
    why: 'Study common conceptual mistakes and develop a more careful approach to reviewing ECG information.',
    image: 'https://cdn.magicpatterns.com/uploads/dJLR9QvrHTpuS99bnU9EDS/BONUS_5_ECG.png',
  },
];
